import { useSelector } from 'react-redux';

import CommonSidebar from 'common/components/Sidebar';
import { useT } from 'common/i18n';
import { getStructure } from 'common/selectors/sidebar/utils';
import sidebarStructure from 'common/selectors/sidebar/affiliates';

const Sidebar = ({ routes }) => (
  <CommonSidebar
    structure={useSelector(
      getStructure(routes, sidebarStructure, useT('sidebar')),
    )}
  />
);

export default Sidebar;
